import {Icon} from './icon';

export class CircleDestination {
  id?: number;
  titles: string[][] = [];
  icons: Icon[] = [];
  urls: string[] = [];

  constructor(data: CircleDestination) {
    this.id = data.id;
    this.titles = data.titles ?? [];
    this.icons = data.icons ?? [];
    this.urls = data.urls ?? [];
  }
}
